import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "appointmentAt",
    "date",
    "time",
    "hour",
    "minutes",
    "period",
  ];

  update() {
    this.appointmentAtTarget.value = `${this.date()} ${this.time()}`;

    if (this.hasPeriodTarget) this.periodTarget.innerHTML = this.period();
  }

  period() {
    const hour = parseInt(this.time(), 10);
    if (isNaN(hour)) return "";

    return hour < 12 ? "AM" : "PM";
  }

  date() {
    return this.dateTarget.value;
  }

  // Either a single "HH:MM" field, or separate hour and minutes fields.
  time() {
    if (this.hasTimeTarget) return this.timeTarget.value;

    return `${this.hour()}:${this.minutes()}`;
  }

  hour() {
    return this.hourTarget.value;
  }

  minutes() {
    return this.minutesTarget.value;
  }
}
